import "./toggleSwitchBtn.css";

const ToggleSwitchBtn = (props) => {
    const { name, id } = props;

    return (
        <div className="toggle-switch-btn section">
            <div className="toggle-switch-btn__inner">
                <input
                    type="checkbox"
                    className="toggle-switch-btn__checkbox"
                    name={name || ""}
                    id={id || ""}
                    {...props}
                />
                <label className="toggle-switch-btn__label" htmlFor={id || ""}>
                    <span className="toggle-switch-btn__inner-text" />
                    <span className="toggle-switch-btn__circle-ball" />
                </label>
            </div>
        </div>
    );
};

export default ToggleSwitchBtn;
